import apiCall from "../api/apiCall";

export const adminDashboardApi = {
	getAdminDashboardData: async (input) => {
		console.log('i',input)
		const userId = input.userId;
		const userToken = input.userToken;
		const clientId = input.clientId
		const siteId = input.siteId;
		const dateFrom = input.dateFrom;
		const dateTo = input.dateTo;

		const url =
			"AdmindashBoard/GetAdminDashboardData" +
			"?userId=" +
			userId +
			"&userToken=" +
			userToken +
			"&clientId=" +
			clientId +
			"&siteId=" +
			siteId +
			"&dateFrom=" +
			dateFrom +
			"&dateTo=" +
			dateTo 
		const response = await apiCall(url, "get");
		return response;
	},
}